<template>
  <div class="invite-form">
    <el-dialog append-to-body title="邀请同事" :visible.sync="visible" @close="close" width="760px">
      <el-form :inline="true" v-for="(item,index) in form" :key="`form${index}`" :model="item" :rules="rules" :ref="`form${index}`">
        <el-form-item label="姓名" class="ml-10" prop="nickName">
          <el-input size="small" v-model="item.nickName" style="width:150px" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机" class="ml-10" prop="phone">
          <el-input size="small" v-model="item.phone" style="width:150px" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="部门" class="ml-10">
          <select-util type="assign" :form="item" :customize="false" k="deptId" width="155px"></select-util>
          <!-- <cascader-util type="team" :form="item" :customize="false" k="deptId" width="155px"></cascader-util> -->
        </el-form-item>
        <template>
          <el-button v-if="form.length > 1" class="mt-5" size="small" type="text" @click="deleteRow(index)">删除</el-button>
        </template>
      </el-form>
      <div class="mt-10 ta-c">
          <el-button size="mini" type="success" @click="addRow">插入行</el-button>
          <el-button size="mini" type="primary" @click="submit">邀请</el-button>
          <el-button size="mini" @click="clear">清空</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mapMutations,mapActions} from 'vuex'
import {
  Req_InviteTeamer
} from '@/request/organize'
import {
  validate,
  required,
  mustNumber,
  phoneLen
} from '@/util/rules'
import {
  deepClone
} from '@/util'
import {
  InviteCreater
} from '@/util/formCreater'
import CascaderUtil from '@/components/Util/CascaderUtil'
import SelectUtil from '@/components/Util/SelectUtil'
export default {
  data() {
    return {
      form:[new InviteCreater()],
      visible: false,
      rules: {
        nickName: [required()],
        phone: [required(),mustNumber(),phoneLen()]
      }
    }
  },
  created() {
    // if(this.departmentList.length === 0) this.getDepartmentList()
  },
  computed: {
    // departmentList() {
    //   return this.$store.state.Organize.departmentList
    // },
    state() {
      return this.$store.state.Setting.inviteState
    }
  },
  methods: {
    ...mapMutations(['refreshInviteState']),
    ...mapActions(['getDepartmentList','getNoDepartPerson']),
    close() {
      this.refreshInviteState(false)
    },
    submit() {
      const promises = []
      this.form.forEach((item,index) => {
        promises.push(validate(this.$refs[`form${index}`][0]))
      })
      Promise.all(promises).then(res => {
        return Req_InviteTeamer(this.form)
      }).then(res => {
        this.$message.success('邀请成功')
        this.form = [new InviteCreater()]
        this.getNoDepartPerson()
      }).catch(err => {
        this.$catchErr(err)
      })
    },
    addRow() {
      if(this.form.length > 9) return this.$message('表单长度最多10行')
      this.form.push(new InviteCreater())
    },
    deleteRow(index) {
      this.form.splice(index,1)
    },
    clear() {
      const form = []
      for(let i = 0; i < this.form.length; i ++) {
        form.push(new InviteCreater())
      }
      this.form = form
    }
  },
  watch: {
    state(nV) {
      this.visible = nV 
    }
  },
  components: {
    CascaderUtil,
    SelectUtil
  }
}
</script>
<style lang="scss">
.invite-form {
  .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Setting/InviteForm.vue